import React from 'react';
import * as styles from './country-acknowledgement.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var CountryAcknowledgementImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-footer/static/country-acknowledgement_18661112.svg";
export var CountryAcknowledgement = () => ___EmotionJSX("div", {
  css: styles.countryAcknowledgementWrap
}, ___EmotionJSX("div", {
  css: styles.countryAcknowledgement
}, ___EmotionJSX("img", {
  src: CountryAcknowledgementImage,
  css: styles.image,
  alt: ""
}), ___EmotionJSX("div", {
  css: styles.text
}, "Allhomes acknowledges the Ngunnawal people, traditional custodians of the lands where Allhomes is situated. We wish to acknowledge and respect their continuing culture and the contribution they make to the life of Canberra and the region. We also acknowledge all other First Nations Peoples on whose lands we work."), ___EmotionJSX("div", {
  css: styles.quote
}, "\"With open hearts and minds, together we grow.\" artwork by", ' ', ___EmotionJSX("span", {
  css: styles.artworkBy
}, "David Williams of Gilimbaa"), ".")));